/**
 * custom style transformer
 */
export class ScaleTransformer extends Konva.Transformer {
	constructor(config) {
		super({
			...config,
			flipEnabled: false,
			borderStrokeWidth: 1,
			anchorStyleFunc: (anchor) => {
				anchor.cornerRadius(10);
				if (anchor.hasName("top-center") || anchor.hasName("bottom-center")) {
					anchor.height(6);
					anchor.offsetY(3);
					anchor.width(26);
					anchor.offsetX(13);
				} else if (anchor.hasName("middle-left") || anchor.hasName("middle-right")) {
					anchor.height(26);
					anchor.offsetY(13);
					anchor.width(6);
					anchor.offsetX(3);
				} else if (anchor.hasName("rotater")) {
					anchor.cornerRadius(15);
					anchor.width(26);
					anchor.height(26);
					anchor.offsetX(13);
					anchor.offsetY(13);
				} else {
					anchor.width(14);
					anchor.offsetX(8);
					anchor.height(14);
					anchor.offsetY(8);
				}
			},
		});

		// Dodanie listenera na zdarzenie 'transform'
		this.on('transform', () => {
			const target = this.nodes()[0];// zobaczymy czy nie zostanie zastąpione event.target
            //console.log(target);
			// teoretycznie transformer nie może wywołać zdarzenia transform bez rzadnych obiektów
			if (target.hasName('image_placeholder')) {
				this.handleImageApplyCrop(target);
			}
			else if (target.hasName('textboxGroup')) {
                this.handleTextScaling(target);
			}
		});
	}
	
	handleImageGetCropRectLiked(image, orginalSize,size, sx, sy) {
        const width = size.width;
        const height = size.height;
        const aspectRatio = width / height;

        let newWidth;
		let newHeight;
		let newScale;
		
        const imageRatio = image.width / image.height;

        if (aspectRatio >= imageRatio) {
            newWidth = image.width;
			newHeight = image.width / aspectRatio;
			newScale = width/newWidth;
            
        } else {
            newWidth = image.height * aspectRatio;
			newHeight = image.height;
			newScale =  height/newHeight;
		}
		let x = ((image.width - newWidth) / 2) * (newScale / sx);
		let y = ((image.height - newHeight) / 2) * (newScale / sy);
		let offsetX = (newWidth / 2) * (newScale / sx);
		let offsetY = (newHeight / 2) * (newScale / sy);
		return {
			fillPatternX: (orginalSize.width)/2,
			fillPatternY: (orginalSize.height)/2,
			fillPatternOffset: { x: image.width / 2, y: image.height/2},  
            fillPatternScale: { x: newScale/sx, y: newScale/sy}, //usunięcie skali obiektu nadrzędnego
        };
	}

	handleImageGetCropCircleLike(image, size,sx,sy) {
		var fillcrop = this.handleImageGetCropRectLiked(image, size,sx,sy);
        return {
            fillPatternOffset: fillcrop.fillPatternOffset,
			fillPatternScale: fillcrop.fillPatternScale,
			fillPatternX: -size.width / 2 / sx, //usunięcie skali obiektu nadrzędnego
			fillPatternY: -size.height / 2 /sy,
        };
	}

	// For Rect like shapes
	handleImageApplyCrop(shape) {
		KonvaCropper.applyCrop(shape);
		/*let fillCrop = null;
		if (shape.getClassName() === 'Rect' || shape.getClassName() === 'Path') {
			if (shape.fillPatternRotation() % 180 !== 0) {
				fillCrop = this.handleImageGetCropRectLiked(
					shape.fillPatternImage(),
					{ width: shape.width(), height: shape.height()},
					{ width: shape.height() * shape.scaleY(), height: shape.width() * shape.scaleX() },
					shape.scaleY(),
					shape.scaleX(),
				);
			} else {
				fillCrop = this.handleImageGetCropRectLiked(
					shape.fillPatternImage(),
					{ width: shape.width(), height: shape.height() },
					{ width: shape.width() * shape.scaleX(), height: shape.height() * shape.scaleY() },
					shape.scaleX(),
					shape.scaleY(),
				);
			}
		} else if (shape.getClassName() === 'Ellipse') {
			fillCrop = this.handleImageGetCropCircleLike(
				shape.fillPatternImage(),
				{ width: shape.radiusX() * 2 * shape.scaleX(), height: shape.radiusY() * 2 * shape.scaleY() } ,
				shape.scaleX(),
				shape.scaleY()
			);
		}
		shape.setAttrs(fillCrop);

		if (shape.getClassName() === 'Path') {
			shape.fillPatternX(shape.getClientRect({ skipTransform: true }).x);
			shape.fillPatternY(shape.getClientRect({ skipTransform: true }).y);
		}*/
	}

	handleTextScaling(textGroup) {
		const anchorName = this.getActiveAnchor();
        const text = textGroup.findOne('Text');
		const borderRect = textGroup.findOne('Rect');
		if (!anchorName) return;

		if (anchorName.includes('top-center') ||
			anchorName.includes('bottom-center') ||
			anchorName.includes('middle-left') ||
			anchorName.includes('middle-right')) {

			const minWidth = text.fontSize() * 2.5 + text.padding()*2;
			const minHeight = text.fontSize() + text.padding() * 2;
			
			// Obliczamy nowe wymiary ramki z uwzględnieniem skali grupy
			const newWidth = Math.max(text.width() * textGroup.scaleX(), minWidth);
			const newHeight = Math.max(text.height() * textGroup.scaleY(), minHeight);

			// Aktualizujemy rozmiar tekstu, odejmując marginesy
			text.width(newWidth);
			text.height(newHeight);
			// Aktualizujemy rozmiary ramki, aby odzwierciedlały nowe wymiary
			if (borderRect) {
				borderRect.width(text.width());
				borderRect.height(text.height());
			}

			//textbox.width(borderRect.width());
            //textbox.height(borderRect.height());

			// Resetujemy skalę grupy, ponieważ rozmiary tekstu i ramki już uwzględniamy
			textGroup.scaleX(1);
			textGroup.scaleY(1);
		}
		else {
			// *** Kod proporcjonalnego skalowania
			const scaleX = textGroup.scaleX();
			//const scaleY = textbox.scaleY();
			const scale = scaleX;//(scaleX + scaleY) / 2;

			text.fontSize(text.fontSize() * scale);
            text.padding(text.padding() * scale);
			text.width(text.width() * scale);
			text.height(text.height() * scale);

			if (borderRect) {
				borderRect.width(text.width());
				borderRect.height(text.height());
			}

			//textbox.width(borderRect.width());
			//textbox.height(borderRect.height());

			textGroup.scaleX(1);
			textGroup.scaleY(1);
		}
	}

	diselectItem() {
		const target = this.nodes()[0];
        if (!target) return;
		if (target.hasName('textboxGroup')) {
			if (target.findOne('Rect'))
				target.findOne('Rect').opacity(1);
		}
        target.draggable(false);
        this.nodes([]);
	}
	selectItem(target) {
        if (this.nodes()[0]) this.diselectItem();
        if (target.hasName('textboxGroup')) {
			if (target.findOne('Rect'))
				target.findOne('Rect').opacity(0);
		}
		target.draggable(true);
		this.nodes([target]);
	}
}
